import { ModelSagres } from "../model-sagres";
import { Aviso } from "./aviso";
import { Destinatario } from "./destinatario";
import { RespostaAviso } from "./resposta-aviso";
import { VisualizacaoAviso } from "./visualizacao-aviso";

export class AvisoResponse extends ModelSagres {
  aviso: Aviso;
  destinatarios: Destinatario[];
  respostas: RespostaAviso[];
  visualizacoes: VisualizacaoAviso[];

  /**
   * Usar o parâmetro opcional para receber um objeto do importador de XML
   * @param obj
   */
  constructor(obj?: any) {
    super();
    if (obj) {
      this.aviso = new Aviso(obj.aviso);
      this.destinatarios = obj.destinatarios.map(
        (destinatario: any) => new Destinatario(destinatario)
      );
      this.respostas = obj.respostas.map(
        (resposta: any) => new RespostaAviso(resposta)
      );
      this.visualizacoes = obj.visualizacoes.map(
        (visualizacao: any) => new VisualizacaoAviso(visualizacao)
      );
    }
  }
}
